/* ==========================================================================
   MAISON NOIR & CO — Live FONT switcher (DEV / PREVIEW ONLY)
   Try modern premium font pairings in real time. Overrides the --mn-font-*
   and Horizon's --font-*--family tokens on :root, and lazy-loads the needed
   families from Google Fonts (same source Shopify uses) so nothing needs to
   be pre-installed. Choice persists in localStorage. Never shown live.
   ========================================================================== */
(function () {
  'use strict';

  // Each pairing: display (headings) + body (everything else) + accent (italic).
  // `gf` = Google Fonts family specs to load (family:weights).
  var FONTS = [
    {
      id: 'fraunces-epilogue', name: 'Fraunces + Epilogue',
      mood: 'Modern editorial · warm-precise (recommended)',
      display: "'Fraunces', Georgia, serif",
      body: "'Epilogue', system-ui, sans-serif",
      accent: "'Fraunces', Georgia, serif",
      gf: ['Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,600;1,9..144,500;1,9..144,600', 'Epilogue:wght@400;500;600;700']
    },
    {
      id: 'fraunces-schibsted', name: 'Fraunces + Schibsted',
      mood: 'Serif display · crisp Scandinavian grotesque',
      display: "'Fraunces', Georgia, serif",
      body: "'Schibsted Grotesk', system-ui, sans-serif",
      accent: "'Fraunces', Georgia, serif",
      gf: ['Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,600;1,9..144,500', 'Schibsted+Grotesk:wght@400;500;600;700']
    },
    {
      id: 'newsreader-archivo', name: 'Newsreader + Archivo',
      mood: 'Literary magazine · long-read serif',
      display: "'Newsreader', Georgia, serif",
      body: "'Archivo', system-ui, sans-serif",
      accent: "'Newsreader', Georgia, serif",
      gf: ['Newsreader:ital,opsz,wght@0,6..72,400;0,6..72,500;0,6..72,600;1,6..72,400', 'Archivo:wght@400;500;600;700']
    },
    {
      id: 'fraunces-manrope', name: 'Fraunces + Manrope',
      mood: 'Softest · boutique, homey warmth',
      display: "'Fraunces', Georgia, serif",
      body: "'Manrope', system-ui, sans-serif",
      accent: "'Fraunces', Georgia, serif",
      gf: ['Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,600;1,9..144,500', 'Manrope:wght@400;500;600;700']
    },
    {
      id: 'epilogue-solo', name: 'Epilogue (all-sans)',
      mood: 'Quiet luxury · Aesop / The Row minimalism',
      display: "'Epilogue', system-ui, sans-serif",
      body: "'Epilogue', system-ui, sans-serif",
      accent: "'Epilogue', system-ui, sans-serif",
      gf: ['Epilogue:ital,wght@0,400;0,500;0,600;0,700;1,500']
    },
    {
      id: 'playfair-inter', name: 'Playfair + Inter',
      mood: 'Classic luxury (the “expected” look)',
      display: "'Playfair Display', Georgia, serif",
      body: "'Inter', system-ui, sans-serif",
      accent: "'Playfair Display', Georgia, serif",
      gf: ['Playfair+Display:ital,wght@0,400;0,600;0,700;1,500', 'Inter:wght@400;500;600;700']
    }
  ];

  var STORE_KEY = 'mn-font-choice';
  var loaded = {};

  function loadGoogleFonts(specs) {
    specs.forEach(function (spec) {
      if (loaded[spec]) return;
      loaded[spec] = true;
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=' + spec + '&display=swap';
      document.head.appendChild(link);
    });
  }

  var APPLIED = null;
  function apply(f) {
    loadGoogleFonts(f.gf);
    var root = document.documentElement;
    var vars = {
      '--mn-font-display': f.display,
      '--mn-font-body': f.body,
      '--mn-font-eyebrow': f.body,
      // Horizon's own role families, so header/footer/native bits follow too
      '--font-heading--family': f.display,
      '--font-body--family': f.body,
      '--font-subheading--family': f.body,
      '--font-accent--family': f.accent
    };
    APPLIED = Object.keys(vars);
    APPLIED.forEach(function (k) { root.style.setProperty(k, vars[k], 'important'); });
    root.setAttribute('data-mn-font', f.id);
    try { localStorage.setItem(STORE_KEY, f.id); } catch (e) {}
    markActive(f.id);
    var cur = document.querySelector('[data-mn-fs-current]');
    if (cur) cur.textContent = f.name;
  }

  function reset() {
    var root = document.documentElement;
    if (APPLIED) APPLIED.forEach(function (k) { root.style.removeProperty(k); });
    root.removeAttribute('data-mn-font');
    try { localStorage.removeItem(STORE_KEY); } catch (e) {}
    markActive(null);
    var cur = document.querySelector('[data-mn-fs-current]');
    if (cur) cur.textContent = 'theme default';
  }

  function markActive(id) {
    var btns = document.querySelectorAll('.mn-fs__opt');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i].dataset.id === id ? 'true' : 'false');
    }
  }

  function isPreviewEnv(root) {
    try {
      var host = location.hostname;
      if (host === '127.0.0.1' || host === 'localhost') return true;
      var qs = location.search || '';
      if (qs.indexOf('preview_theme_id') !== -1 || qs.indexOf('_fd=') !== -1 || qs.indexOf('_ab=') !== -1) return true;
      if (window.self !== window.top && document.referrer.indexOf('/admin') !== -1) return true;
      if (root && root.getAttribute('data-mn-liquid-preview') === 'true') return true;
    } catch (e) {}
    return false;
  }

  function build() {
    var root = document.querySelector('[data-mn-font-switcher]');
    if (!root) return;
    if (!isPreviewEnv(root)) return;
    root.hidden = false;

    var toggle = root.querySelector('.mn-fs__toggle');
    var panel = root.querySelector('.mn-fs__panel');
    toggle.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
    });

    var list = root.querySelector('[data-mn-fs-list]');
    FONTS.forEach(function (f) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mn-fs__opt';
      b.dataset.id = f.id;
      b.setAttribute('aria-pressed', 'false');
      b.innerHTML =
        '<span class="mn-fs__opt-text">' +
          '<span class="mn-fs__opt-name">' + f.name + '</span>' +
          '<span class="mn-fs__opt-mood">' + f.mood + '</span>' +
        '</span>';
      b.addEventListener('click', function () { apply(f); });
      list.appendChild(b);
    });

    var resetBtn = root.querySelector('[data-mn-fs-reset]');
    if (resetBtn) resetBtn.addEventListener('click', reset);

    var saved = null;
    try { saved = localStorage.getItem(STORE_KEY); } catch (e) {}
    if (saved) {
      var found = FONTS.filter(function (f) { return f.id === saved; })[0];
      if (found) apply(found);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
